import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import englishTranslations from "../locales/en/translation.json";
import greekTranslations from "../locales/el/translation.json";

export const LANGUAGE_STORAGE_KEY = "wpos-language";
export const supportedLanguages = ["el", "en"];

const savedLanguage = typeof window !== "undefined" ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;
const initialLanguage = supportedLanguages.includes(savedLanguage) ? savedLanguage : "el";

i18n.use(initReactI18next).init({
  resources: {
    el: {
      translation: greekTranslations,
    },
    en: {
      translation: englishTranslations,
    },
  },
  lng: initialLanguage,
  fallbackLng: "el",
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

const applyLanguage = (language) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }

  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
};

applyLanguage(initialLanguage);
i18n.on("languageChanged", applyLanguage);

export default i18n;
